import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as EmptyIcon } from '../../../assets/icons/stats-empty.svg';
import { ReactComponent as StatusUpIcon } from '../../../assets/icons/stats-up.svg';
import { useAppSelector } from '../../../store/reducers';
import AboutHorses from '../../HorsesCard/AboutHorses/AboutHorses';
import styles from '../HorseStats/HorseStats.module.scss';
export const ShowIcons = (num) => {
    if (num === 0) {
        return _jsx(EmptyIcon, { className: styles.icon });
    }
    else if (num === 1) {
        return _jsx(StatusUpIcon, {});
    }
    else {
        return (_jsxs(_Fragment, { children: [_jsx(StatusUpIcon, {}), _jsx(StatusUpIcon, {})] }));
    }
};
const defaultJockey = {
    wisdom: 1,
    courage: 1,
    determination: 1,
    personality: 'Balanced'
};
const TotalStats = () => {
    var _a;
    let jockey = (_a = useAppSelector((state) => state.jockeys.jockey)) !== null && _a !== void 0 ? _a : defaultJockey;
    const parseJockeys = {
        wisdom: ShowIcons(jockey.wisdom),
        courage: ShowIcons(jockey.courage),
        determination: ShowIcons(jockey.determination),
        races_joined: 0,
        personality: jockey.personality
    };
    return _jsx(AboutHorses, { borderRight: true, className: styles.element, elem: parseJockeys });
};
export default TotalStats;
